/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import BloodBankRequest from './blood-bank-request';
import BloodBankRequestDetail from './blood-bank-request-detail';
import BloodBankRequestUpdate from './blood-bank-request-update';
import BloodBankRequestDeleteDialog from './blood-bank-request-delete-dialog';

const BloodBankRequestRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<BloodBankRequest />} />
    <Route path="new" element={<BloodBankRequestUpdate />} />
    <Route path=":id">
      <Route index element={<BloodBankRequestDetail />} />
      <Route path="edit" element={<BloodBankRequestUpdate />} />
      <Route path="delete" element={<BloodBankRequestDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default BloodBankRequestRoutes;
